import React from 'react';
import cross from './images/cross.webp';
import logo from './images/logo.png';

function SideSlide({ isOpen, onClose }) {
  return (
    <div className={`sideSlide ${isOpen ? 'slideScreen' : ''}`}>
      <div className="sideSliderInner">
        <img src={logo} width={40} />
        <h4>
          DRINKWATR,<br />
          RENEWED WITH PURPOSE, WE HAVE REPOSITIONED TO FOCUS EXCLUSIVELY ON REUSABLE BOTTLE TECHNOLOGY. OUR PRODUCT DESIGN IS GROUNDED IN PREVENTATIVE HEALTH, ELEVATED DESIGN, FRONTIER INNOVATION, AND SUSTAINABILITY.
        </h4>
        <div className="cut" onClick={onClose}>
          <img src={cross} alt="Close" />
        </div>
      </div>
    </div>
  );
}

export default SideSlide;